import React from "react";
import SelectDropdown from "../../components-react/SelectDropdown";
import MultiSelectDropdown from "../../components-react/MultiSelectDropdown";
import { Button } from "react-bootstrap";

const IncentivePenaltyForm = () => {
  return (
    <form className="formContainer incentiveFormContainer">
      <div className="addonBox">
        <div className="slotNoRemoveBtn">
          <span className="slots">Enter Incentive details</span>
        </div>

        <div className="formInputsGrid">
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Incentive for
            </label>

            <div className="commonWrapper">
              <MultiSelectDropdown
                // options={weekdaysData}
                // selectedValue={formValues.weekdays}
                // setSelectedValue={(selectedValue) =>
                //   handleFormChange("weekdays", selectedValue)
                // }
                name=" Incentive for"
              />
            </div>
          </div>
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Incentive Categroy
            </label>

            <div className="commonWrapper">
              <SelectDropdown
                // options={gymData}
                // selectedOption={formValues.selectedPtCategory}
                // setSelectedOption={(selectedValue) =>
                //   handleFormChange("selectedPtCategory", selectedValue)
                // }
                name="Incentive Categroy"
              />
            </div>
          </div>
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Incentive Scheme
            </label>

            <div className="commonWrapper">
              <MultiSelectDropdown
                // options={weekdaysData}
                // selectedValue={formValues.weekdays}
                // setSelectedValue={(selectedValue) =>
                //   handleFormChange("weekdays", selectedValue)
                // }
                name="Incentive Scheme"
              />
            </div>
          </div>
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Incentive type
            </label>

            <div className="commonWrapper">
              <SelectDropdown
                // options={gymData}
                // selectedOption={formValues.selectedPtLevel}
                // setSelectedOption={(selectedValue) =>
                //   handleFormChange("selectedPtLevel", selectedValue)
                // }
                name="Incentive type"
              />
            </div>
          </div>
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Percentage of
            </label>

            <div className="commonWrapper">
              <MultiSelectDropdown
                // options={weekdaysData}
                // selectedValue={formValues.weekdays}
                // setSelectedValue={(selectedValue) =>
                //   handleFormChange("weekdays", selectedValue)
                // }
                name="Percentage Of"
              />
            </div>
          </div>
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Select Gym
            </label>

            <div className="commonWrapper">
              <SelectDropdown
                // options={gymData}
                // selectedOption={formValues.selectedPtLevel}
                // setSelectedOption={(selectedValue) =>
                //   handleFormChange("selectedPtLevel", selectedValue)
                // }
                name="Select Gym"
              />
            </div>
          </div>
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Percentage %
            </label>

            <input
              type="number"
              placeholder="Enter Duration"
              className="formInput"
              name="duration"
              // value={formValues.duration}
              // onChange={(e) => handleFormChange("duration", e.target.value)}
            />
          </div>
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Penalty Scheme
            </label>

            <div className="commonWrapper">
              <MultiSelectDropdown
                // options={weekdaysData}
                // selectedValue={formValues.weekdays}
                // setSelectedValue={(selectedValue) =>
                //   handleFormChange("weekdays", selectedValue)
                // }
                name=" Penalty Scheme"
              />
            </div>
          </div>
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Penalty type
            </label>

            <div className="commonWrapper">
              <SelectDropdown
                // options={gymData}
                // selectedOption={formValues.selectedPtCategory}
                // setSelectedOption={(selectedValue) =>
                //   handleFormChange("selectedPtCategory", selectedValue)
                // }
                name="Penalty type"
              />
            </div>
          </div>
          <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Penalty Percentage of
            </label>

            <div className="commonWrapper">
              <SelectDropdown
                // options={gymData}
                // selectedOption={formValues.selectedPtCategory}
                // setSelectedOption={(selectedValue) =>
                //   handleFormChange("selectedPtCategory", selectedValue)
                // }
                name="Penalty Percentage"
              />
            </div>
          </div>

          {/* <div className="formInputBox">
            <label htmlFor="gym" className="formInputLabel">
              Incentive icon
            </label>

            <div className="commonWrapper">
              <div className="icon-upload-btn">
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                  >
                    <path
                      d="M24.4395 17.315C23.8418 16.7181 23.0316 16.3828 22.187 16.3828C21.3423 16.3828 20.5321 16.7181 19.9345 17.315L7.43945 29.7569C9.23508 29.7569 14.6432 29.7569 26.5645 29.7569C27.6359 29.7529 28.681 29.425 29.5627 28.8164C30.4444 28.2077 31.1215 27.3467 31.5051 26.3463C31.5051 26.2188 31.6007 26.0806 31.6432 25.9425L31.7707 25.5069C31.8058 25.3385 31.8306 25.1682 31.8451 24.9969C31.8499 24.951 31.8499 24.9047 31.8451 24.8588C31.8494 24.8377 31.8494 24.816 31.8451 24.795L24.4395 17.315Z"
                      fill="#535353"
                    />
                    <path
                      d="M31.8747 9.05256C31.7475 7.73376 31.1321 6.51009 30.1493 5.6216C29.1664 4.73311 27.8871 4.24394 26.5622 4.25006H7.43716C6.11227 4.24394 4.8329 4.73311 3.85006 5.6216C2.86721 6.51009 2.25184 7.73376 2.12466 9.05256C2.11209 9.22232 2.11209 9.39279 2.12466 9.56256V24.4376C2.1144 24.6216 2.1144 24.806 2.12466 24.9901C2.15085 25.1689 2.18632 25.3462 2.23091 25.5213C2.61068 26.6752 3.26731 27.7185 4.14341 28.5601C4.41609 28.7927 4.7201 28.9858 5.04654 29.1338L18.4022 15.7888C18.8956 15.2941 19.4819 14.9016 20.1273 14.6337C20.7727 14.3659 21.4646 14.2281 22.1634 14.2281C22.8622 14.2281 23.5541 14.3659 24.1995 14.6337C24.8449 14.9016 25.4312 15.2941 25.9247 15.7888L31.8747 21.7388V9.56256C31.8872 9.39279 31.8872 9.22232 31.8747 9.05256ZM8.49966 12.7501C8.07938 12.7501 7.66853 12.6254 7.31908 12.3919C6.96962 12.1584 6.69725 11.8266 6.53642 11.4383C6.37558 11.05 6.3335 10.6227 6.41549 10.2105C6.49749 9.79828 6.69987 9.41964 6.99706 9.12246C7.29425 8.82527 7.67289 8.62288 8.0851 8.54089C8.49731 8.45889 8.92457 8.50098 9.31286 8.66181C9.70116 8.82265 10.033 9.09502 10.2665 9.44447C10.5 9.79392 10.6247 10.2048 10.6247 10.6251C10.6247 11.1886 10.4008 11.7291 10.0023 12.1277C9.60375 12.5262 9.06325 12.7501 8.49966 12.7501Z"
                      fill="#535353"
                    />
                  </svg>
                </div>
                <div className="image">
                  <ImageUploading
                    multiple
                    value={images}
                    onChange={onChange}
                    maxNumber={maxNumber}
                    dataURLKey="data_url"
                  >
                    {({
                      imageList,
                      onImageUpload,
                      onImageRemoveAll,
                      onImageUpdate,
                      onImageRemove,
                      isDragging,
                      dragProps,
                    }) => (
                      <div className="upload__image-wrapper">
                        {images?.length === 0 ? (
                          <>
                            <button
                              style={isDragging ? { color: "red" } : undefined}
                              onClick={onImageUpload}
                              {...dragProps}
                            >
                              Click or Drop
                            </button>
                            &nbsp;
                            <button onClick={onImageRemoveAll}>Remove</button>
                          </>
                        ) : (
                          <>
                            {imageList.map((image, index) => (
                              <div key={index} className="image-item">
                                <img
                                  src={image["data_url"]}
                                  alt=""
                                  width="100"
                                />
                                <div className="image-item__btn-wrapper">
                                  <button onClick={() => onImageUpdate(index)}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-cloud-plus"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                      />
                                      <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                    </svg>
                                  </button>
                                  <button onClick={() => onImageRemove(index)}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-x"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    )}
                  </ImageUploading>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <div className="formButtons">
        <div className="checkboxes"></div>
        <Button
          className="saveBtn"
          variant="danger"
          //   onClick={() => handleStepChange(activeStep + 1)}
        >
          Save
        </Button>
      </div>
    </form>
  );
};

export default IncentivePenaltyForm;
